import U from '../js/utils';
// ensure push
export default async ({elID, ddData, valueDataName, textDataName, labelName, requiredYN, onchange, initValue}) => {
  return new Promise(async (resolve, reject) => {
    try {
      // Add null check for ddData
      if (!ddData || !Array.isArray(ddData)) {
        ddData = []; // Set to empty array as fallback
      }
      
      const opts = await U.buildOptsDD_v2({data: ddData, value: valueDataName, text: textDataName, initValue});

      const div = `
        <div id="${elID}Div" class="input-group">
          ${labelName ? `<label for="${elID}">${labelName}</label>` : ''}
          <select id="${elID}" name="${elID}" val="select" 
          ${requiredYN ? 'required' : ''} 
          ${onchange ? `onchange="${onchange}"` : ''} 
          >
          ${opts}
          </select>
        <span fb-for="${elID}"></span>
        </div>
      `;

      resolve(U.createHTMLElementFromString(div));
    } catch (error) {
      reject(error);
    }
  });
};
